import React from 'react';
import styles from '../../styles/components/answers/RadioButton.module.css';

export interface RadioButtonData {
  hasSelection: boolean;
  onCompletion?: (s: boolean) => void;
  key?: string;
  tabIndex?: number;
}

export const RadioButton: React.FC<RadioButtonData> = data => {
  return (
    <div
      className={
        data.hasSelection ? styles.selectedRadioButton : styles.radioButton
      }
      onClick={() => {
        data.onCompletion && data.onCompletion(!data.hasSelection);
      }}
      onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => {
        e.key === 'Enter' &&
          data.onCompletion &&
          data.onCompletion(!data.hasSelection);
      }}
      tabIndex={data.tabIndex}
    ></div>
  );
};
